<template>
  <div class="merchant-settled-content">
    <div class="merchant-settled-content-form">
      <h1>Business information</h1>
      <div>
        <!-- <el-form
          :model="infoModel"
          :rules="rules"
          ref="ruleForm"
          label-width="230px"
        >
          <el-form-item label="Shop logo" prop="logo">
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="infoModel.logo" :src="$getImageUrl(infoModel.logo)" class="avatar" />
              <img
                v-else
                class="avatar-uploader-icon"
                :src="require('@/assets/image/camera.png')"
                alt=""
              />
            </el-upload>
          </el-form-item>
          <el-form-item label="Shop name" prop="name">
            <el-input
              v-model="infoModel.name"
              placeholder="Please enter store name"
            />
          </el-form-item>
          <el-form-item label="Shop Adress" prop="address">
            <el-input
              v-model="infoModel.address"
              placeholder="Please enter the store address"
            />
          </el-form-item>
          <el-form-item label="Invitation Code" prop="code">
            <el-input
              v-model="infoModel.code"
              placeholder="Please enter the invitation code"
            />
          </el-form-item>
          <el-form-item label="Actual name" prop="actualName">
            <el-input
              v-model="infoModel.actualName"
              placeholder="Please input your Actual name"
            />
          </el-form-item>
          <el-form-item label="Country" prop="country">
            <el-menu class="el-menu-demo" mode="horizontal">
              <el-submenu index="2">
                <template slot="title">
                  <div class="flex-start country-select">
                    <img :src="langIcon[infoModel.country]" alt="" />
                    <span>当前地区</span>
                  </div>
                </template>

                <el-menu-item v-for="item in countryList" :key="item.key">
                  <div class="country-item" @click="selectCountry(item.key)">
                    <img :src="item.icon" :alt="item.key" />
                    <span>{{ item.name }}</span>
                  </div>
                </el-menu-item>
              </el-submenu>
            </el-menu>
            <el-dropdown trigger="click">
              <div class="lang-select flex-between">
                <div class="flex-start">
                  <img :src="langIcon[infoModel.country]" alt="" />
                  <span>{{ currentCountryName }}</span>
                </div>

                <i class="el-icon-caret-bottom"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in countryList" :key="item.key">
                  <div class="country-item" @click="selectCountry(item.key)">
                    <img :src="item.icon" :alt="item.key" />
                    <span>{{ item.name }}</span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item label="ID number" prop="id">
            <el-input
              v-model="infoModel.id"
              placeholder="Please input your ID number"
            />
          </el-form-item>
          <el-form-item label="ID photo/passport upload">
            <el-row>
              <el-col :span="4">
                <el-upload
                  class="avatar-uploader"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <div class="avatar-uploader-item">
                    <img
                      v-if="infoModel.photoFront"
                      :src="$getImageUrl(infoModel.photoFront)"
                      class="avatar"
                    />
                    <img
                      v-else
                      class="avatar-uploader-icon"
                      :src="require('@/assets/image/camera.png')"
                      alt=""
                    />
                    <div class="avatar-uploader-tips">ID photo front</div>
                  </div>
                </el-upload>
              </el-col>
              <el-col :span="4">
                <el-upload
                  class="avatar-uploader"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <div class="avatar-uploader-item">
                    <img
                      v-if="infoModel.photoBack"
                      :src="$getImageUrl(infoModel.photoBack)"
                      class="avatar"
                    />
                    <img
                      v-else
                      class="avatar-uploader-icon"
                      :src="require('@/assets/image/camera.png')"
                      alt=""
                    />
                    <div class="avatar-uploader-tips">ID photo back</div>
                  </div>
                </el-upload>
              </el-col>
              <el-col :span="4">
                <el-upload
                  class="avatar-uploader"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <div class="avatar-uploader-item">
                    <img
                      v-if="infoModel.holdingPhont"
                      :src="infoModel.holdingPhont"
                      class="avatar"
                    />
                    <img
                      v-else
                      class="avatar-uploader-icon"
                      :src="require('@/assets/image/camera.png')"
                      alt=""
                    />
                    <div class="avatar-uploader-tips">Holding ID photo</div>
                  </div>
                </el-upload>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="Shooting examples">
            <el-row>
              <el-col :span="4">
                <div class="flex-start upload-img-wrap">
                  <img
                    class="upload-img"
                    :src="require('@/assets/image/01.png')"
                    alt=""
                  />
                  <img :src="require('@/assets/image/gou.png')" alt="" />
                </div>
              </el-col>
              <el-col :span="4">
                <div class="flex-start upload-img-wrap">
                  <img
                    class="upload-img"
                    :src="require('@/assets/image/02.png')"
                    alt=""
                  />
                  <img :src="require('@/assets/image/cha.png')" alt="" />
                </div>
              </el-col>
              <el-col :span="4">
                <div class="flex-start upload-img-wrap">
                  <img
                    class="upload-img"
                    :src="require('@/assets/image/03.png')"
                    alt=""
                  />
                  <img :src="require('@/assets/image/cha.png')" alt="" />
                </div>
              </el-col>
            </el-row>
          </el-form-item>


        </el-form> -->










<!-- ; -------------------------------------------------------------------------------------------- ; -->

<el-form ref="form" :model="formData" :rules="rules" label-width="120px"  v-loading="loading"  >
        <el-form-item label="username" required prop="username">
          <el-input  v-model="formData.username" maxlength="30" />
        </el-form-item>
        <el-form-item label="password" required prop="password">
          <el-input v-model="formData.password" show-password maxlength="20" />
        </el-form-item>
        <el-form-item label="passwordConfirm" required prop="passwordConfirm">
          <el-input v-model="formData.passwordConfirm" show-password maxlength="20" />
        </el-form-item>
        <el-form-item label="email" required prop="email">
          <el-input v-model="formData.email" maxlength="30" />
        </el-form-item>
        <el-form-item label="mobile" required prop="mobile">
          <el-input v-model="formData.mobile" maxlength="15" />
        </el-form-item>

        <!-- <el-form-item label="merchantRankId" prop="merchantRankId">
          <el-select v-model="formData.merchantRankId" placeholder="请选择用户等级">
            <el-option
              v-for="item in merchantRankIdOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设置">
          <el-switch
            v-model="formData.lockFlag"
            width="46"
            active-text="是否启用" >
          </el-switch>

        </el-form-item> -->


        <el-form-item :required="merchantItem.isRequired "  v-for="(merchantItem, index) in merchantItemList" :key="index"
                      :label="merchantItem.name" :prop="merchantItem.name">
          <!--输入框 13-->
          <el-input maxlength="200"
            v-if="merchantItem.type == 'NAME' || merchantItem.type == 'LICENSE_NUMBER' || merchantItem.type == 'LEGAL_PERSON' || merchantItem.type == 'ID_CARD' || merchantItem.type == 'PHONE' || merchantItem.type == 'ORGANIZATION_CODE' || merchantItem.type == 'IDENTIFICATION_NUMBER' || merchantItem.type == 'BANK_NAME' || merchantItem.type == 'BANK_ACCOUNT' || merchantItem.type === 'TEXT'"
            v-model="merchantItems['merchantItem_'+merchantItem.id]"
            />
          <!--日期 17-->
          <el-date-picker v-if="merchantItem.type == 'DATE'" style="width: 100%;" clearable size="small"
                          type="datetime"
                          v-model="merchantItems['merchantItem_'+merchantItem.id]"
                          value-format="yyyy-MM-dd HH:mm:ss" >
          </el-date-picker>
          <!-- 图片 16 -->
          <imageUpload
            v-if="merchantItem.type == 'LICENSE_IMAGE' || merchantItem.type == 'ID_CARD_IMAGE' || merchantItem.type == 'ORGANIZATION_IMAGE' || merchantItem.type == 'TAX_IMAGE' || merchantItem.type == 'IMAGE'"
            :uploadImgUrl="uploadUrl" v-on:handleImagesUrl="setImagesUrl"
            :imgId="'merchantItem_'+merchantItem.id"
            :value="merchantItems['merchantItem_'+merchantItem.id]"/>
          <!--多选框 15-->
          <el-checkbox-group v-if="merchantItem.type == 'CHECKBOX'"
                             v-model="merchantItems['merchantItem_'+merchantItem.id]">
            <el-checkbox v-for="option in merchantItem.options" :label="option" :key="option">{{ option }}
            </el-checkbox>
          </el-checkbox-group>
          <!-- 下拉单选  14 -->
          <el-select style="width:100%;" v-if="merchantItem.type == 'SELECT'"
                     v-model="merchantItems['merchantItem_'+merchantItem.id]" >
            <el-option
              v-for="item in merchantItem.options"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>


      </el-form>

<!------------------------------------------------------------------------------------------------------>


      </div>
    </div>
    <div class="merchant-settled-content-agreement">
      <div class="agreement-btn">
        <el-button type="primary" @click="submitForm">Submit application</el-button>
      </div>
    </div>
    <el-dialog
      class="merchant-settled-content-dialog"
      :visible.sync="dialogVisible"
      :center="true"
    >
      <div slot="title" class="dialog-title">
        <span>Submitted successfully</span>
      </div>
      <div class="dialog-content">
        <img :src="require('@/assets/image/wanc.png')" alt="Success" />
        <p>
          The store check-in application has been submitted, if you need to
          modify it, please contact customer service
        </p>
        <el-button type="primary">Contact Customer Service</el-button>
      </div>
      <span slot="footer"></span>
    </el-dialog>
  </div>
</template>

<script>
import zhIcon from '@/assets/image/cn.png'
import enIcon from '@/assets/image/en.png'
import twIcon from '@/assets/image/tw.png'
import ImageUpload from '@/components/ImageUpload/index.vue';

import {
		check_username,
		check_email,
		check_mobile,
		index,
		submit,
	} from '@/api/upms/merchant_register.js'


export default {
  name: 'EsBusinessInfo',
  data() {
    return {
      checked: false,
      dialogVisible: false,
      infoModel: {
        logo: '',
        name: '',
        address: '',
        code: '',
        actualName: '',
        id: '',
        country: 'en',
        photoFront: '',
        photoBack: '',
        holdingPhont: '',
     },
      // rules: {
      //   logo: [
      //     {
      //       required: true,
      //       message: 'Please upload your logo',
      //       trigger: 'blur',
      //     },
      //   ],
      //   name: [
      //     {
      //       required: true,
      //       message: 'Please enter store name',
      //       trigger: 'blur',
      //     },
      //   ],
      //   address: [
      //     {
      //       required: true,
      //       message: 'Please enter the store address',
      //       trigger: 'blur',
      //     },
      //   ],
      //   code: [
      //     {
      //       required: true,
      //       message: 'Please enter the invitation code',
      //       trigger: 'blur',
      //     },
      //   ],
      //   actualName: [
      //     {
      //       required: true,
      //       message: 'Please input your Actual name',
      //       trigger: 'blur',
      //     },
      //   ],
      //   country: [
      //     {
      //       required: true,
      //       message: 'Please enter store name',
      //       trigger: 'blur',
      //     },
      //   ],
      //   id: [
      //     {
      //       required: true,
      //       message: 'Please input your ID number',
      //       trigger: 'blur',
      //     },
      //   ],
      //   country: [
      //     {
      //       required: true,
      //       message: 'Please select a country',
      //       trigger: 'blur',
      //     },
      //   ],
      // },
      langIcon: {
        'zh-CN': zhIcon,
        en: enIcon,
        'zh-TW': twIcon,
      },
      countryList: [
        {
          key: 'zh-CN',
          icon: zhIcon,
          name: '中文简体',
        },
        {
          key: 'zh-TW',
          icon: twIcon,
          name: '中文繁體',
        },
        {
          key: 'en',
          icon: enIcon,
          name: 'English',
        },
      ],

        // 查询参数
        queryParams: {
          pageNumber: 1,
          pageSize: 10,
          username: null,
        },
        // 表单参数
        formData: {
          username:'',
          password:'',
          passwordConfirm:'',
          email:'',
          mobile:'',
          // merchantRankId:''
        },
        // 表单校验
        rules: {},
        merchantRankIdOptions:[],
        genders:[],
        merchantItems:{},
        isdisabled:false,
        merchantItemList:[],
        imgsrc: '',
        idxs: [],
        dataTimeValue: [],
        imageValue: [],
        uploadUrl: '/upms/file/upload?fileType=image&path=shop-upms-merchant'


    }
  },
  components: { ImageUpload },
  computed: {
    // currentCountryName() {
    //   return this.countryList.find(
    //     (item) => item.key === this.infoModel.country,
    //   ).name
    // },
  },
  created() {
    this.handleAdd();
  },
  methods: {
    handleAvatarSuccess() {},
    beforeAvatarUpload() {},
    selectCountry(key) {
      this.infoModel.country = key
    },
    submit() {
      this.dialogVisible = true
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
        }
      })
    },


    /** 新增按钮操作 */
    handleAdd() {
      this.loading = true;
      // this.reset();
      // this.merchantItems = [];
      this.isdisabled = false;
      index().then(response => {
        this.loading = false;
        // this.genders = response.data.data.genders? response.data.data.genders : null;
        // this.merchantRankIdOptions = response.data.data.merchantRanks? response.data.data.merchantRanks : null;
        this.merchantItemList = response.data.data.merchantItemList?response.data.data.merchantItemList:null;
        // this.merchantItems = response.data.data.merchantItems?response.data.data.merchantItems:null;
        if (this.merchantItemList && 0 < this.merchantItemList.length) {
          this.merchantItemList.forEach((item, k) => {
            this.dataTimeValue.push('');
            this.imageValue.push('');
            this.idxs.push(0);
            if (item.type == 'CHECKBOX') {
              this.merchantItems['merchantItem_' + item.id] = [];
            }
            if (item.options && 0 < item.options.length) {
              let options = item.options;
              for (let i = 0; i < options.length; i++) {
                if (this.merchantItems) {
                  for (let z = 0; z < this.merchantItems.length; z++) {
                    if (this.merchantItems[z] === options[i]) {
                      this.idxs[k] = i;
                    }
                  }
                }
              }
            }
          })
        }
        this.loading = false;
        this.open = true;
      }).finally(() => {
        this.loading = false;
      });
    },

    setImagesUrl(url, id) {
      this.merchantItems[id] = url;
    },

    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if(this.formData.password!=this.formData.passwordConfirm){
            this.$message("密码和确认密码不一致");
            return ;
          }
          let params={'merchantItems':this.merchantItems};
          submit(this.merchantItems,this.formData).then(response => {
            this.$message("提交成功");
            this.$router.push('/')
				  }).catch(error => {
              let errResponse = JSON.parse(error.request.response ? error.request.response : '');
                if (errResponse && errResponse.message) {
                  this.$message({
                  message: '参数异常',
                  type: "error",
                   });
              }
				})
        }
      });
    },

    // merchant_register_submit(merchantItems,data) {
				
		// 	},

  },
}
</script>

<style lang="scss">
.merchant-settled-content {
  position: relative;
  background-color: var(--color-white);
  padding: 0 20px;
  &-form {
    border-radius: 4px;
    border: 1px solid var(--color-border);
    position: relative;
    top: -90px;
    background-color: var(--color-white);
    padding: 24px;
    h1 {
      font-weight: 700;
      font-size: 24px;
      margin-bottom: 40px;
      color: var(--color-title);
    }
    .avatar-uploader {
      &-tips {
        font-weight: 400;
        font-size: 12px;
        color: var(--color-title);
        margin-top: -15px;
      }
    }
    .avatar-uploader-icon {
      width: 91px;
      height: 94px;
    }
    .upload-img-wrap {
      flex-direction: column;
    }
    .upload-img {
      width: 100%;
      height: 100%;
      max-width: 100px;
      max-height: 65px;
      margin-bottom: 10px;
    }
    .el-form-item__label {
      text-align: left;
    }

    .el-submenu {
      width: 100%;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
    }
    .el-submenu__title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px !important;
      line-height: 40px !important;
    }

    .el-menu.el-menu--horizontal {
      border: 0;
    }
    .country-select {
      width: 100%;
      cursor: pointer;
      img {
        margin-right: 8px;
      }
    }
  }

  &-agreement {
    font-weight: 500;
    font-size: 12px;
    width: 100%;
    text-align: center;
    margin: -60px 0 100px 0;
    .agreement-btn {
      margin-top: 50px;
      .el-button {
        width: 100%;
        max-width: 475px;
        height: 52px;
        font-weight: 400;
        font-size: 16px;
      }
    }
  }

  &-dialog {
    .el-dialog__header {
      padding: 0;
      border-radius: 6px;
    }
    .el-dialog__close {
      font-size: 24px;
    }
    .el-dialog__headerbtn {
      top: 14px;
      right: 14px;
    }
    .el-dialog {
      width: 80vw;
      max-width: 600px;
    }
    .dialog-title {
      height: 50px;
      line-height: 50px;
      background-color: #f5f5f5;
      font-weight: 700;
      font-size: 18px;
      color: var(--color-title);
      border-radius: 6px;
    }
    .dialog-content {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      img {
        margin: 80px 0 50px 0;
      }

      p {
        padding: 0 40px;
        margin-bottom: 50px;
        text-align: center;
        font-weight: 500;
        font-size: 16px;
        color: var(--color-title);
      }

      .el-button {
        width: 100%;
        max-width: 450px;
        height: 50px;
      }
    }
  }
}

.country-item {
  padding: 0 10px;
  img {
    margin-right: 5px;
  }
}
</style>
